import { apiClient } from './apiClient';

export class TemplateService {
    constructor() {
        this.BASE_URL = '/templates';
    }

    async getNotesTemplateTypes() {
        try {
            const response = await apiClient.get(
                `${this.BASE_URL}/notes/types`
            );
            return response
        } catch (error) {
            console.error('Error fetching template types:', error);
            throw error;
        }
    }

    async getPatientMessagesTemplateTypes() {
        try {
            const response = await apiClient.get(
                `${this.BASE_URL}/patient_messages/types`
            );
            return response
        } catch (error) {
            console.error('Error fetching template types:', error);
            throw error;
        }
    }

    async getPatientMessagesTemplate() {
        try {
            const response = await apiClient.get(
                `${this.BASE_URL}/patient_messages/templates`
            );
            return response
        } catch (error) {
            console.error('Error fetching template types:', error);
            throw error;
        }
    }

    async getTemplateByType(type) {
        try {
            const response = await apiClient.get(
                `${this.BASE_URL}/by-type/${type}`
            );
            return response
        } catch (error) {
            console.error('Error fetching template by type:', error);
            throw error;
        }
    }

    async applyTemplate(templateId, channel, variables) {
        try {
            const response = await apiClient.post(
                `${this.BASE_URL}/apply`,
                { templateId, channel, variables }
            );
            return response
        } catch (error) {
            console.error('Error applying template:', error);
            throw error;
        }
    }

    async getContextTemplate(templateId, entityId, entityType) {
        try {
            const response = await apiClient.post(
                `${this.BASE_URL}/context`,
                { templateId, entityId, entityType }
            );
            return response
        } catch (error) {
            console.error('Error applying template:', error);
            throw error;
        }
    }
}

export const templateService = new TemplateService();
export default templateService;